import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { INotificationWaveCreated } from "@/types/feed.types";
import WaveHeaderFollow, { WaveFollowBtnSize } from "@/components/waves/header/WaveHeaderFollow";
import type { ApiWave } from "@/generated/models/ApiWave";
import { commonApiFetch } from "@/services/api/common-api";
import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import NotificationHeader from "../subcomponents/NotificationHeader";
import NotificationTimestamp from "../subcomponents/NotificationTimestamp";
export default function NotificationWaveCreated(t0) {
  const $ = _c(24);
  const {
    notification
  } = t0;
  let t1;
  if ($[0] !== notification.additional_context.wave_id) {
    t1 = {
      queryKey: [QueryKey.WAVE, {
        wave_id: notification.additional_context.wave_id
      }],
      queryFn: async () => await commonApiFetch({
        endpoint: `waves/${notification.additional_context.wave_id}`
      })
    };
    $[0] = notification.additional_context.wave_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: wave
  } = useQuery(t1);
  const {
    isApp
  } = useDeviceInfo();
  const t2 = wave?.chat.scope.group?.is_direct_message ?? false;
  let t3;
  if ($[2] !== isApp || $[3] !== notification.additional_context.wave_id || $[4] !== t2) {
    t3 = getWaveRoute({
      waveId: notification.additional_context.wave_id,
      isDirectMessage: t2,
      isApp
    });
    $[2] = isApp;
    $[3] = notification.additional_context.wave_id;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const invitationHref = t3;
  let t4;
  if ($[6] !== wave) {
    t4 = wave && <WaveHeaderFollow wave={wave} subscribeToAllDrops={true} size={WaveFollowBtnSize.SMALL} />;
    $[6] = wave;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== notification.related_identity) {
    t5 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
    $[8] = notification.related_identity;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="tw-flex tw-gap-x-2 tw-items-center">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">invited you to a wave:</span>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = wave?.name;
  let t9;
  if ($[14] !== invitationHref || $[15] !== t8) {
    t9 = <Link href={invitationHref} className="tw-text-sm tw-font-medium tw-no-underline tw-text-primary-400 hover:tw-text-primary-300">{t8}</Link>;
    $[14] = invitationHref;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== notification.created_at) {
    t10 = <NotificationTimestamp createdAt={notification.created_at} />;
    $[17] = notification.created_at;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== notification.related_identity || $[20] !== t10 || $[21] !== t6 || $[22] !== t9) {
    t11 = <div className="tw-w-full"><NotificationHeader author={notification.related_identity} actions={t6}>{t7}{t9}{t10}</NotificationHeader></div>;
    $[19] = notification.related_identity;
    $[20] = t10;
    $[21] = t6;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}